import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditQuestionComp from "./Component/EditQuestionComp"


const EditQuestion =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditQuestionComp />
        </div>
        <Footer />
        </>
    )
}

export default EditQuestion